module.exports = __webpack_public_path__ + "img/1437812269.e82c4bcf.jpg";